import React, { useState, useEffect } from "react";

const TatilVeIzin = () => {
  // Tatil Ayarları State'leri
  const [cumartesi, setCumartesi] = useState(false);
  const [pazar, setPazar] = useState(false);
  const [resmiTatiller, setResmiTatiller] = useState(false);

  // Tatil Listesi State'i
  const [tatiller, setTatiller] = useState([]);

  // İzin Hesaplama State'leri
  const [baslangic, setBaslangic] = useState("");
  const [bitis, setBitis] = useState("");
  const [izinGunleri, setIzinGunleri] = useState(null);

  // Tatil Listesini Fetch Et
  useEffect(() => {
    const fetchTatiller = async () => {
      try {
        const response = await fetch("http://localhost:5000/tatiller");
        const data = await response.json();
        setTatiller(data.tatiller);
      } catch (error) {
        console.error("Hata:", error);
      }
    };

    fetchTatiller();
  }, []);

  // Ayarları Kaydet
  const handleAyarKaydet = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("http://localhost:5000/ayarlar", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          cumartesiCalisma: cumartesi,
          pazarCalisma: pazar,
          resmiTatilCalisma: resmiTatiller,
        }),
      });
      const data = await response.json();
      alert(data.message);
    } catch (error) {
      console.error("Hata:", error);
    }
  };

  // İzin Hesapla
  const handleIzinHesapla = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("http://localhost:5000/izin-hesapla", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ baslangic, bitis }),
      });
      const data = await response.json();
      setIzinGunleri(data.izinGunleri);
    } catch (error) {
      console.error("Hata:", error);
    }
  };

  return (
    <div>
      <h1>Tatil ve İzin Yönetimi</h1>

      {/* Tatil Ayarları */}
      <section>
        <h2>Tatil Ayarları</h2>
        <form onSubmit={handleAyarKaydet}>
          <label>
            Cumartesi Çalışma:
            <input
              type="checkbox"
              checked={cumartesi}
              onChange={(e) => setCumartesi(e.target.checked)}
            />
          </label>
          <br />
          <label>
            Pazar Çalışma:
            <input
              type="checkbox"
              checked={pazar}
              onChange={(e) => setPazar(e.target.checked)}
            />
          </label>
          <br />
          <label>
            Resmi Tatiller Çalışma:
            <input
              type="checkbox"
              checked={resmiTatiller}
              onChange={(e) => setResmiTatiller(e.target.checked)}
            />
          </label>
          <br />
          <button type="submit">Kaydet</button>
        </form>
      </section>

      <hr />

      {/* Tatil Listesi */}
      <section>
        <h2>Tatil Listesi</h2>
        <ul>
          {tatiller.map((tatil, index) => (
            <li key={index}>
              {tatil.tarih} - {tatil.aciklama || "Resmi Tatil"}
            </li>
          ))}
        </ul>
      </section>

      <hr />

      {/* İzin Hesaplama */}
      <section>
        <h2>İzin Hesaplama</h2>
        <form onSubmit={handleIzinHesapla}>
          <label>
            Başlangıç Tarihi:
            <input
              type="date"
              value={baslangic}
              onChange={(e) => setBaslangic(e.target.value)}
            />
          </label>
          <br />
          <label>
            Bitiş Tarihi:
            <input
              type="date"
              value={bitis}
              onChange={(e) => setBitis(e.target.value)}
            />
          </label>
          <br />
          <button type="submit">Hesapla</button>
        </form>
        {izinGunleri !== null && (
          <p>Toplam İş Günü: {izinGunleri} gün</p>
        )}
      </section>
    </div>
  );
};

export default TatilVeIzin;
